
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/help',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/help/',
            getPage: () => import(
              /* webpackChunkName: "help" */
              '/work/help/_site_tmp/_help.js'
            ),
            
            
          },{
            path: '/help/getting-started/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started" */
              '/work/help/_site_tmp/_help_getting-started.js'
            ),
            
            
          },{
            path: '/help/getting-started/access-tokens/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-access-tokens" */
              '/work/help/_site_tmp/_help_getting-started_access-tokens.js'
            ),
            
            
          },{
            path: '/help/getting-started/add-markers/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-add-markers" */
              '/work/help/_site_tmp/_help_getting-started_add-markers.js'
            ),
            
            
          },{
            path: '/help/getting-started/attribution/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-attribution" */
              '/work/help/_site_tmp/_help_getting-started_attribution.js'
            ),
            
            
          },{
            path: '/help/getting-started/creating-data/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-creating-data" */
              '/work/help/_site_tmp/_help_getting-started_creating-data.js'
            ),
            
            
          },{
            path: '/help/getting-started/directions/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-directions" */
              '/work/help/_site_tmp/_help_getting-started_directions.js'
            ),
            
            
          },{
            path: '/help/getting-started/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-geocoding" */
              '/work/help/_site_tmp/_help_getting-started_geocoding.js'
            ),
            
            
          },{
            path: '/help/getting-started/geospatial-analysis/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-geospatial-analysis" */
              '/work/help/_site_tmp/_help_getting-started_geospatial-analysis.js'
            ),
            
            
          },{
            path: '/help/getting-started/imagery/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-imagery" */
              '/work/help/_site_tmp/_help_getting-started_imagery.js'
            ),
            
            
          },{
            path: '/help/getting-started/map-design/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-map-design" */
              '/work/help/_site_tmp/_help_getting-started_map-design.js'
            ),
            
            
          },{
            path: '/help/getting-started/mapbox-data/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-mapbox-data" */
              '/work/help/_site_tmp/_help_getting-started_mapbox-data.js'
            ),
            
            
          },{
            path: '/help/getting-started/mapbox-developers-discord/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-mapbox-developers-discord" */
              '/work/help/_site_tmp/_help_getting-started_mapbox-developers-discord.js'
            ),
            
            
          },{
            path: '/help/getting-started/mobile-apps/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-mobile-apps" */
              '/work/help/_site_tmp/_help_getting-started_mobile-apps.js'
            ),
            
            
          },{
            path: '/help/getting-started/static-maps/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-static-maps" */
              '/work/help/_site_tmp/_help_getting-started_static-maps.js'
            ),
            
            
          },{
            path: '/help/getting-started/unity/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-unity" */
              '/work/help/_site_tmp/_help_getting-started_unity.js'
            ),
            
            
          },{
            path: '/help/getting-started/uploading-data/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-uploading-data" */
              '/work/help/_site_tmp/_help_getting-started_uploading-data.js'
            ),
            
            
          },{
            path: '/help/getting-started/web-apps/',
            getPage: () => import(
              /* webpackChunkName: "help-getting-started-web-apps" */
              '/work/help/_site_tmp/_help_getting-started_web-apps.js'
            ),
            
            
          },{
            path: '/help/glossary/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary" */
              '/work/help/_site_tmp/_help_glossary.js'
            ),
            
            
          },{
            path: '/help/glossary/access-token/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-access-token" */
              '/work/help/_site_tmp/_help_glossary_access-token.js'
            ),
            
            
          },{
            path: '/help/glossary/annotation/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-annotation" */
              '/work/help/_site_tmp/_help_glossary_annotation.js'
            ),
            
            
          },{
            path: '/help/glossary/attribution/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-attribution" */
              '/work/help/_site_tmp/_help_glossary_attribution.js'
            ),
            
            
          },{
            path: '/help/glossary/baselayer/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-baselayer" */
              '/work/help/_site_tmp/_help_glossary_baselayer.js'
            ),
            
            
          },{
            path: '/help/glossary/bearing/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-bearing" */
              '/work/help/_site_tmp/_help_glossary_bearing.js'
            ),
            
            
          },{
            path: '/help/glossary/bounding-box/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-bounding-box" */
              '/work/help/_site_tmp/_help_glossary_bounding-box.js'
            ),
            
            
          },{
            path: '/help/glossary/camera/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-camera" */
              '/work/help/_site_tmp/_help_glossary_camera.js'
            ),
            
            
          },{
            path: '/help/glossary/cartocss/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-cartocss" */
              '/work/help/_site_tmp/_help_glossary_cartocss.js'
            ),
            
            
          },{
            path: '/help/glossary/classic-style/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-classic-style" */
              '/work/help/_site_tmp/_help_glossary_classic-style.js'
            ),
            
            
          },{
            path: '/help/glossary/csv/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-csv" */
              '/work/help/_site_tmp/_help_glossary_csv.js'
            ),
            
            
          },{
            path: '/help/glossary/data-driven-styling/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-data-driven-styling" */
              '/work/help/_site_tmp/_help_glossary_data-driven-styling.js'
            ),
            
            
          },{
            path: '/help/glossary/dataset-id/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-dataset-id" */
              '/work/help/_site_tmp/_help_glossary_dataset-id.js'
            ),
            
            
          },{
            path: '/help/glossary/dataset/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-dataset" */
              '/work/help/_site_tmp/_help_glossary_dataset.js'
            ),
            
            
          },{
            path: '/help/glossary/datasets-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-datasets-api" */
              '/work/help/_site_tmp/_help_glossary_datasets-api.js'
            ),
            
            
          },{
            path: '/help/glossary/directions-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-directions-api" */
              '/work/help/_site_tmp/_help_glossary_directions-api.js'
            ),
            
            
          },{
            path: '/help/glossary/expression/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-expression" */
              '/work/help/_site_tmp/_help_glossary_expression.js'
            ),
            
            
          },{
            path: '/help/glossary/feature-querying/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-feature-querying" */
              '/work/help/_site_tmp/_help_glossary_feature-querying.js'
            ),
            
            
          },{
            path: '/help/glossary/features/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-features" */
              '/work/help/_site_tmp/_help_glossary_features.js'
            ),
            
            
          },{
            path: '/help/glossary/filter/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-filter" */
              '/work/help/_site_tmp/_help_glossary_filter.js'
            ),
            
            
          },{
            path: '/help/glossary/font-stack/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-font-stack" */
              '/work/help/_site_tmp/_help_glossary_font-stack.js'
            ),
            
            
          },{
            path: '/help/glossary/geocoding-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-geocoding-api" */
              '/work/help/_site_tmp/_help_glossary_geocoding-api.js'
            ),
            
            
          },{
            path: '/help/glossary/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-geocoding" */
              '/work/help/_site_tmp/_help_glossary_geocoding.js'
            ),
            
            
          },{
            path: '/help/glossary/geojson/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-geojson" */
              '/work/help/_site_tmp/_help_glossary_geojson.js'
            ),
            
            
          },{
            path: '/help/glossary/gpx/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-gpx" */
              '/work/help/_site_tmp/_help_glossary_gpx.js'
            ),
            
            
          },{
            path: '/help/glossary/icon/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-icon" */
              '/work/help/_site_tmp/_help_glossary_icon.js'
            ),
            
            
          },{
            path: '/help/glossary/iframe/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-iframe" */
              '/work/help/_site_tmp/_help_glossary_iframe.js'
            ),
            
            
          },{
            path: '/help/glossary/isochrone-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-isochrone-api" */
              '/work/help/_site_tmp/_help_glossary_isochrone-api.js'
            ),
            
            
          },{
            path: '/help/glossary/kml/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-kml" */
              '/work/help/_site_tmp/_help_glossary_kml.js'
            ),
            
            
          },{
            path: '/help/glossary/lat-lon/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-lat-lon" */
              '/work/help/_site_tmp/_help_glossary_lat-lon.js'
            ),
            
            
          },{
            path: '/help/glossary/layer/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-layer" */
              '/work/help/_site_tmp/_help_glossary_layer.js'
            ),
            
            
          },{
            path: '/help/glossary/layout-paint-property/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-layout-paint-property" */
              '/work/help/_site_tmp/_help_glossary_layout-paint-property.js'
            ),
            
            
          },{
            path: '/help/glossary/leaflet/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-leaflet" */
              '/work/help/_site_tmp/_help_glossary_leaflet.js'
            ),
            
            
          },{
            path: '/help/glossary/line/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-line" */
              '/work/help/_site_tmp/_help_glossary_line.js'
            ),
            
            
          },{
            path: '/help/glossary/maki/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-maki" */
              '/work/help/_site_tmp/_help_glossary_maki.js'
            ),
            
            
          },{
            path: '/help/glossary/map-id/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-map-id" */
              '/work/help/_site_tmp/_help_glossary_map-id.js'
            ),
            
            
          },{
            path: '/help/glossary/map-loads/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-map-loads" */
              '/work/help/_site_tmp/_help_glossary_map-loads.js'
            ),
            
            
          },{
            path: '/help/glossary/map-matching-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-map-matching-api" */
              '/work/help/_site_tmp/_help_glossary_map-matching-api.js'
            ),
            
            
          },{
            path: '/help/glossary/map-view/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-map-view" */
              '/work/help/_site_tmp/_help_glossary_map-view.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-android-sdk/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-android-sdk" */
              '/work/help/_site_tmp/_help_glossary_mapbox-android-sdk.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-components-for-framer-x/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-components-for-framer-x" */
              '/work/help/_site_tmp/_help_glossary_mapbox-components-for-framer-x.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-editor/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-editor" */
              '/work/help/_site_tmp/_help_glossary_mapbox-editor.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-gl-js/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-gl-js" */
              '/work/help/_site_tmp/_help_glossary_mapbox-gl-js.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-gl/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-gl" */
              '/work/help/_site_tmp/_help_glossary_mapbox-gl.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-ios-sdk/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-ios-sdk" */
              '/work/help/_site_tmp/_help_glossary_mapbox-ios-sdk.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-js/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-js" */
              '/work/help/_site_tmp/_help_glossary_mapbox-js.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-maps-sdk-for-unity/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-maps-sdk-for-unity" */
              '/work/help/_site_tmp/_help_glossary_mapbox-maps-sdk-for-unity.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-navigation-sdk/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-navigation-sdk" */
              '/work/help/_site_tmp/_help_glossary_mapbox-navigation-sdk.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-satellite/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-satellite" */
              '/work/help/_site_tmp/_help_glossary_mapbox-satellite.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-studio-classic/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-studio-classic" */
              '/work/help/_site_tmp/_help_glossary_mapbox-studio-classic.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-studio/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-studio" */
              '/work/help/_site_tmp/_help_glossary_mapbox-studio.js'
            ),
            
            
          },{
            path: '/help/glossary/mapbox-tiling-service/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapbox-tiling-service" */
              '/work/help/_site_tmp/_help_glossary_mapbox-tiling-service.js'
            ),
            
            
          },{
            path: '/help/glossary/mapnik/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mapnik" */
              '/work/help/_site_tmp/_help_glossary_mapnik.js'
            ),
            
            
          },{
            path: '/help/glossary/maps-sdk-for-react-native/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-maps-sdk-for-react-native" */
              '/work/help/_site_tmp/_help_glossary_maps-sdk-for-react-native.js'
            ),
            
            
          },{
            path: '/help/glossary/marker/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-marker" */
              '/work/help/_site_tmp/_help_glossary_marker.js'
            ),
            
            
          },{
            path: '/help/glossary/matrix-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-matrix-api" */
              '/work/help/_site_tmp/_help_glossary_matrix-api.js'
            ),
            
            
          },{
            path: '/help/glossary/mbtiles/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-mbtiles" */
              '/work/help/_site_tmp/_help_glossary_mbtiles.js'
            ),
            
            
          },{
            path: '/help/glossary/monthly-active-users/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-monthly-active-users" */
              '/work/help/_site_tmp/_help_glossary_monthly-active-users.js'
            ),
            
            
          },{
            path: '/help/glossary/offline-region/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-offline-region" */
              '/work/help/_site_tmp/_help_glossary_offline-region.js'
            ),
            
            
          },{
            path: '/help/glossary/optimization-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-optimization-api" */
              '/work/help/_site_tmp/_help_glossary_optimization-api.js'
            ),
            
            
          },{
            path: '/help/glossary/osm/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-osm" */
              '/work/help/_site_tmp/_help_glossary_osm.js'
            ),
            
            
          },{
            path: '/help/glossary/overzoom/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-overzoom" */
              '/work/help/_site_tmp/_help_glossary_overzoom.js'
            ),
            
            
          },{
            path: '/help/glossary/point/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-point" */
              '/work/help/_site_tmp/_help_glossary_point.js'
            ),
            
            
          },{
            path: '/help/glossary/polygon/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-polygon" */
              '/work/help/_site_tmp/_help_glossary_polygon.js'
            ),
            
            
          },{
            path: '/help/glossary/projection/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-projection" */
              '/work/help/_site_tmp/_help_glossary_projection.js'
            ),
            
            
          },{
            path: '/help/glossary/quadtree/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-quadtree" */
              '/work/help/_site_tmp/_help_glossary_quadtree.js'
            ),
            
            
          },{
            path: '/help/glossary/raster-tiles-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-raster-tiles-api" */
              '/work/help/_site_tmp/_help_glossary_raster-tiles-api.js'
            ),
            
            
          },{
            path: '/help/glossary/raster/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-raster" */
              '/work/help/_site_tmp/_help_glossary_raster.js'
            ),
            
            
          },{
            path: '/help/glossary/routing-profile/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-routing-profile" */
              '/work/help/_site_tmp/_help_glossary_routing-profile.js'
            ),
            
            
          },{
            path: '/help/glossary/runtime-styling/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-runtime-styling" */
              '/work/help/_site_tmp/_help_glossary_runtime-styling.js'
            ),
            
            
          },{
            path: '/help/glossary/shapefile/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-shapefile" */
              '/work/help/_site_tmp/_help_glossary_shapefile.js'
            ),
            
            
          },{
            path: '/help/glossary/simplestyle/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-simplestyle" */
              '/work/help/_site_tmp/_help_glossary_simplestyle.js'
            ),
            
            
          },{
            path: '/help/glossary/sku-token/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-sku-token" */
              '/work/help/_site_tmp/_help_glossary_sku-token.js'
            ),
            
            
          },{
            path: '/help/glossary/source-layer/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-source-layer" */
              '/work/help/_site_tmp/_help_glossary_source-layer.js'
            ),
            
            
          },{
            path: '/help/glossary/source/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-source" */
              '/work/help/_site_tmp/_help_glossary_source.js'
            ),
            
            
          },{
            path: '/help/glossary/sprite/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-sprite" */
              '/work/help/_site_tmp/_help_glossary_sprite.js'
            ),
            
            
          },{
            path: '/help/glossary/static-images-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-static-images-api" */
              '/work/help/_site_tmp/_help_glossary_static-images-api.js'
            ),
            
            
          },{
            path: '/help/glossary/static-tiles-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-static-tiles-api" */
              '/work/help/_site_tmp/_help_glossary_static-tiles-api.js'
            ),
            
            
          },{
            path: '/help/glossary/style-component/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-style-component" */
              '/work/help/_site_tmp/_help_glossary_style-component.js'
            ),
            
            
          },{
            path: '/help/glossary/style-id/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-style-id" */
              '/work/help/_site_tmp/_help_glossary_style-id.js'
            ),
            
            
          },{
            path: '/help/glossary/style-optimized-vector-tiles/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-style-optimized-vector-tiles" */
              '/work/help/_site_tmp/_help_glossary_style-optimized-vector-tiles.js'
            ),
            
            
          },{
            path: '/help/glossary/style-url/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-style-url" */
              '/work/help/_site_tmp/_help_glossary_style-url.js'
            ),
            
            
          },{
            path: '/help/glossary/style/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-style" */
              '/work/help/_site_tmp/_help_glossary_style.js'
            ),
            
            
          },{
            path: '/help/glossary/styles-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-styles-api" */
              '/work/help/_site_tmp/_help_glossary_styles-api.js'
            ),
            
            
          },{
            path: '/help/glossary/svg/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-svg" */
              '/work/help/_site_tmp/_help_glossary_svg.js'
            ),
            
            
          },{
            path: '/help/glossary/symbol-layer/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-symbol-layer" */
              '/work/help/_site_tmp/_help_glossary_symbol-layer.js'
            ),
            
            
          },{
            path: '/help/glossary/telemetry/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-telemetry" */
              '/work/help/_site_tmp/_help_glossary_telemetry.js'
            ),
            
            
          },{
            path: '/help/glossary/tiff/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tiff" */
              '/work/help/_site_tmp/_help_glossary_tiff.js'
            ),
            
            
          },{
            path: '/help/glossary/tilejson/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tilejson" */
              '/work/help/_site_tmp/_help_glossary_tilejson.js'
            ),
            
            
          },{
            path: '/help/glossary/tilemill/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tilemill" */
              '/work/help/_site_tmp/_help_glossary_tilemill.js'
            ),
            
            
          },{
            path: '/help/glossary/tilequery-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tilequery-api" */
              '/work/help/_site_tmp/_help_glossary_tilequery-api.js'
            ),
            
            
          },{
            path: '/help/glossary/tileset-billing-metrics/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tileset-billing-metrics" */
              '/work/help/_site_tmp/_help_glossary_tileset-billing-metrics.js'
            ),
            
            
          },{
            path: '/help/glossary/tileset-id/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tileset-id" */
              '/work/help/_site_tmp/_help_glossary_tileset-id.js'
            ),
            
            
          },{
            path: '/help/glossary/tileset-recipe/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tileset-recipe" */
              '/work/help/_site_tmp/_help_glossary_tileset-recipe.js'
            ),
            
            
          },{
            path: '/help/glossary/tileset-source/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tileset-source" */
              '/work/help/_site_tmp/_help_glossary_tileset-source.js'
            ),
            
            
          },{
            path: '/help/glossary/tileset/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tileset" */
              '/work/help/_site_tmp/_help_glossary_tileset.js'
            ),
            
            
          },{
            path: '/help/glossary/tokens-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-tokens-api" */
              '/work/help/_site_tmp/_help_glossary_tokens-api.js'
            ),
            
            
          },{
            path: '/help/glossary/trip/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-trip" */
              '/work/help/_site_tmp/_help_glossary_trip.js'
            ),
            
            
          },{
            path: '/help/glossary/turf/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-turf" */
              '/work/help/_site_tmp/_help_glossary_turf.js'
            ),
            
            
          },{
            path: '/help/glossary/uploads-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-uploads-api" */
              '/work/help/_site_tmp/_help_glossary_uploads-api.js'
            ),
            
            
          },{
            path: '/help/glossary/vector-tiles-api/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-vector-tiles-api" */
              '/work/help/_site_tmp/_help_glossary_vector-tiles-api.js'
            ),
            
            
          },{
            path: '/help/glossary/vector-tiles/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-vector-tiles" */
              '/work/help/_site_tmp/_help_glossary_vector-tiles.js'
            ),
            
            
          },{
            path: '/help/glossary/wordpress/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-wordpress" */
              '/work/help/_site_tmp/_help_glossary_wordpress.js'
            ),
            
            
          },{
            path: '/help/glossary/worldview/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-worldview" */
              '/work/help/_site_tmp/_help_glossary_worldview.js'
            ),
            
            
          },{
            path: '/help/glossary/zoom-extent/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-zoom-extent" */
              '/work/help/_site_tmp/_help_glossary_zoom-extent.js'
            ),
            
            
          },{
            path: '/help/glossary/zoom-level/',
            getPage: () => import(
              /* webpackChunkName: "help-glossary-zoom-level" */
              '/work/help/_site_tmp/_help_glossary_zoom-level.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting" */
              '/work/help/_site_tmp/_help_troubleshooting.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/account-lockout/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-account-lockout" */
              '/work/help/_site_tmp/_help_troubleshooting_account-lockout.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/address-geocoding-format-guide/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-address-geocoding-format-guide" */
              '/work/help/_site_tmp/_help_troubleshooting_address-geocoding-format-guide.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/adjust-tileset-zoom-extent/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-adjust-tileset-zoom-extent" */
              '/work/help/_site_tmp/_help_troubleshooting_adjust-tileset-zoom-extent.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/android-apk-size/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-android-apk-size" */
              '/work/help/_site_tmp/_help_troubleshooting_android-apk-size.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/api-caching/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-api-caching" */
              '/work/help/_site_tmp/_help_troubleshooting_api-caching.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/blank-tiles/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-blank-tiles" */
              '/work/help/_site_tmp/_help_troubleshooting_blank-tiles.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/change-language/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-change-language" */
              '/work/help/_site_tmp/_help_troubleshooting_change-language.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/collaboration-best-practices/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-collaboration-best-practices" */
              '/work/help/_site_tmp/_help_troubleshooting_collaboration-best-practices.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/cors-errors/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-cors-errors" */
              '/work/help/_site_tmp/_help_troubleshooting_cors-errors.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/csv-upload-errors/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-csv-upload-errors" */
              '/work/help/_site_tmp/_help_troubleshooting_csv-upload-errors.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/firewalls/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-firewalls" */
              '/work/help/_site_tmp/_help_troubleshooting_firewalls.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/how-area-is-calculated/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-how-area-is-calculated" */
              '/work/help/_site_tmp/_help_troubleshooting_how-area-is-calculated.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/how-to-use-mapbox-securely/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-how-to-use-mapbox-securely" */
              '/work/help/_site_tmp/_help_troubleshooting_how-to-use-mapbox-securely.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/implementation-support/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-implementation-support" */
              '/work/help/_site_tmp/_help_troubleshooting_implementation-support.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/integrate-mapbox-visual-with-power-bi/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-integrate-mapbox-visual-with-power-bi" */
              '/work/help/_site_tmp/_help_troubleshooting_integrate-mapbox-visual-with-power-bi.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/ios-framework-size/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-ios-framework-size" */
              '/work/help/_site_tmp/_help_troubleshooting_ios-framework-size.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/ios-sdk-installation/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-ios-sdk-installation" */
              '/work/help/_site_tmp/_help_troubleshooting_ios-sdk-installation.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/ios-sdk-submission/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-ios-sdk-submission" */
              '/work/help/_site_tmp/_help_troubleshooting_ios-sdk-submission.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/japan-specific-considerations-search-api/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-japan-specific-considerations-search-api" */
              '/work/help/_site_tmp/_help_troubleshooting_japan-specific-considerations-search-api.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/manage-fontstacks/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-manage-fontstacks" */
              '/work/help/_site_tmp/_help_troubleshooting_manage-fontstacks.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/manage-tileset-costs/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-manage-tileset-costs" */
              '/work/help/_site_tmp/_help_troubleshooting_manage-tileset-costs.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/manage-web-map-costs/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-manage-web-map-costs" */
              '/work/help/_site_tmp/_help_troubleshooting_manage-web-map-costs.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/mapbox-browser-support/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-mapbox-browser-support" */
              '/work/help/_site_tmp/_help_troubleshooting_mapbox-browser-support.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/mapbox-gl-js-performance/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-mapbox-gl-js-performance" */
              '/work/help/_site_tmp/_help_troubleshooting_mapbox-gl-js-performance.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/migrate-legacy-static-tiles-api/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-migrate-legacy-static-tiles-api" */
              '/work/help/_site_tmp/_help_troubleshooting_migrate-legacy-static-tiles-api.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/mobile-offline/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-mobile-offline" */
              '/work/help/_site_tmp/_help_troubleshooting_mobile-offline.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/multilayer-tilesets/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-multilayer-tilesets" */
              '/work/help/_site_tmp/_help_troubleshooting_multilayer-tilesets.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/optimize-map-label-placement/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-optimize-map-label-placement" */
              '/work/help/_site_tmp/_help_troubleshooting_optimize-map-label-placement.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/private-access-token-android-and-ios/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-private-access-token-android-and-ios" */
              '/work/help/_site_tmp/_help_troubleshooting_private-access-token-android-and-ios.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/raster-transparency-issues/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-raster-transparency-issues" */
              '/work/help/_site_tmp/_help_troubleshooting_raster-transparency-issues.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/reduce-tileset-sources/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-reduce-tileset-sources" */
              '/work/help/_site_tmp/_help_troubleshooting_reduce-tileset-sources.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/reporting-a-problem/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-reporting-a-problem" */
              '/work/help/_site_tmp/_help_troubleshooting_reporting-a-problem.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/streets-v8-migration-guide/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-streets-v8-migration-guide" */
              '/work/help/_site_tmp/_help_troubleshooting_streets-v8-migration-guide.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/studio-svg-upload-errors/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-studio-svg-upload-errors" */
              '/work/help/_site_tmp/_help_troubleshooting_studio-svg-upload-errors.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/transfer-styles-between-accounts/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-transfer-styles-between-accounts" */
              '/work/help/_site_tmp/_help_troubleshooting_transfer-styles-between-accounts.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/transition-from-mapbox-js-to-mapbox-gl-js/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-transition-from-mapbox-js-to-mapbox-gl-js" */
              '/work/help/_site_tmp/_help_troubleshooting_transition-from-mapbox-js-to-mapbox-gl-js.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/understanding-tilesets-pricing/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-understanding-tilesets-pricing" */
              '/work/help/_site_tmp/_help_troubleshooting_understanding-tilesets-pricing.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/upload-large-source-files-mts/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-upload-large-source-files-mts" */
              '/work/help/_site_tmp/_help_troubleshooting_upload-large-source-files-mts.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/uploads/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-uploads" */
              '/work/help/_site_tmp/_help_troubleshooting_uploads.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/use-custom-mapbox-styles-in-tableau/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-use-custom-mapbox-styles-in-tableau" */
              '/work/help/_site_tmp/_help_troubleshooting_use-custom-mapbox-styles-in-tableau.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/using-recolorable-images-in-mapbox-maps/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-using-recolorable-images-in-mapbox-maps" */
              '/work/help/_site_tmp/_help_troubleshooting_using-recolorable-images-in-mapbox-maps.js'
            ),
            
            
          },{
            path: '/help/troubleshooting/working-with-large-geojson-data/',
            getPage: () => import(
              /* webpackChunkName: "help-troubleshooting-working-with-large-geojson-data" */
              '/work/help/_site_tmp/_help_troubleshooting_working-with-large-geojson-data.js'
            ),
            
            
          },{
            path: '/help/tutorials/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials" */
              '/work/help/_site_tmp/_help_tutorials.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-3d-buildings-studio-data-driven-styling-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-3d-buildings-studio-data-driven-styling-video" */
              '/work/help/_site_tmp/_help_tutorials_add-3d-buildings-studio-data-driven-styling-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-3d-buildings-studio/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-3d-buildings-studio" */
              '/work/help/_site_tmp/_help_tutorials_add-3d-buildings-studio.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-bilingual-labels-to-a-map-using-expressions-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-bilingual-labels-to-a-map-using-expressions-video" */
              '/work/help/_site_tmp/_help_tutorials_add-bilingual-labels-to-a-map-using-expressions-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-custom-font-studio-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-custom-font-studio-video" */
              '/work/help/_site_tmp/_help_tutorials_add-custom-font-studio-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-gradient-route-line-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-gradient-route-line-video" */
              '/work/help/_site_tmp/_help_tutorials_add-gradient-route-line-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-points-pt-1/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-points-pt-1" */
              '/work/help/_site_tmp/_help_tutorials_add-points-pt-1.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-points-pt-2/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-points-pt-2" */
              '/work/help/_site_tmp/_help_tutorials_add-points-pt-2.js'
            ),
            
            
          },{
            path: '/help/tutorials/add-points-pt-3/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-add-points-pt-3" */
              '/work/help/_site_tmp/_help_tutorials_add-points-pt-3.js'
            ),
            
            
          },{
            path: '/help/tutorials/alteryx-macro-isochrones-to-map-travel-distances-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-alteryx-macro-isochrones-to-map-travel-distances-video" */
              '/work/help/_site_tmp/_help_tutorials_alteryx-macro-isochrones-to-map-travel-distances-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/alteryx-macro-search-for-batch-geocoding-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-alteryx-macro-search-for-batch-geocoding-video" */
              '/work/help/_site_tmp/_help_tutorials_alteryx-macro-search-for-batch-geocoding-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/analysis-with-turf-mapbox-js/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-analysis-with-turf-mapbox-js" */
              '/work/help/_site_tmp/_help_tutorials_analysis-with-turf-mapbox-js.js'
            ),
            
            
          },{
            path: '/help/tutorials/analysis-with-turf/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-analysis-with-turf" */
              '/work/help/_site_tmp/_help_tutorials_analysis-with-turf.js'
            ),
            
            
          },{
            path: '/help/tutorials/android-navigation-sdk/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-android-navigation-sdk" */
              '/work/help/_site_tmp/_help_tutorials_android-navigation-sdk.js'
            ),
            
            
          },{
            path: '/help/tutorials/android-vision-ar-customization/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-android-vision-ar-customization" */
              '/work/help/_site_tmp/_help_tutorials_android-vision-ar-customization.js'
            ),
            
            
          },{
            path: '/help/tutorials/android-vision-custom-detections-tutorial/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-android-vision-custom-detections-tutorial" */
              '/work/help/_site_tmp/_help_tutorials_android-vision-custom-detections-tutorial.js'
            ),
            
            
          },{
            path: '/help/tutorials/android-vision-poi-drawing/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-android-vision-poi-drawing" */
              '/work/help/_site_tmp/_help_tutorials_android-vision-poi-drawing.js'
            ),
            
            
          },{
            path: '/help/tutorials/android-vision-sdk-usb-camera/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-android-vision-sdk-usb-camera" */
              '/work/help/_site_tmp/_help_tutorials_android-vision-sdk-usb-camera.js'
            ),
            
            
          },{
            path: '/help/tutorials/arcgis-online-mapbox-basemap/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-arcgis-online-mapbox-basemap" */
              '/work/help/_site_tmp/_help_tutorials_arcgis-online-mapbox-basemap.js'
            ),
            
            
          },{
            path: '/help/tutorials/bezier-curves-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-bezier-curves-video" */
              '/work/help/_site_tmp/_help_tutorials_bezier-curves-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/building-a-store-locator-js/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-building-a-store-locator-js" */
              '/work/help/_site_tmp/_help_tutorials_building-a-store-locator-js.js'
            ),
            
            
          },{
            path: '/help/tutorials/building-a-store-locator/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-building-a-store-locator" */
              '/work/help/_site_tmp/_help_tutorials_building-a-store-locator.js'
            ),
            
            
          },{
            path: '/help/tutorials/carto/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-carto" */
              '/work/help/_site_tmp/_help_tutorials_carto.js'
            ),
            
            
          },{
            path: '/help/tutorials/choropleth-studio-gl-pt-1/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-choropleth-studio-gl-pt-1" */
              '/work/help/_site_tmp/_help_tutorials_choropleth-studio-gl-pt-1.js'
            ),
            
            
          },{
            path: '/help/tutorials/choropleth-studio-gl-pt-2/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-choropleth-studio-gl-pt-2" */
              '/work/help/_site_tmp/_help_tutorials_choropleth-studio-gl-pt-2.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-3d-terrain-map-hypsometric-tinting-studio-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-3d-terrain-map-hypsometric-tinting-studio-video" */
              '/work/help/_site_tmp/_help_tutorials_create-3d-terrain-map-hypsometric-tinting-studio-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-a-custom-style/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-a-custom-style" */
              '/work/help/_site_tmp/_help_tutorials_create-a-custom-style.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-a-map-in-unity/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-a-map-in-unity" */
              '/work/help/_site_tmp/_help_tutorials_create-a-map-in-unity.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-a-map-with-data-visualization-component/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-a-map-with-data-visualization-component" */
              '/work/help/_site_tmp/_help_tutorials_create-a-map-with-data-visualization-component.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-a-timezone-finder-with-mapbox-tilequery-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-a-timezone-finder-with-mapbox-tilequery-api" */
              '/work/help/_site_tmp/_help_tutorials_create-a-timezone-finder-with-mapbox-tilequery-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-and-edit-data-in-studio-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-and-edit-data-in-studio-video" */
              '/work/help/_site_tmp/_help_tutorials_create-and-edit-data-in-studio-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-interactive-hover-effects-with-mapbox-gl-js/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-interactive-hover-effects-with-mapbox-gl-js" */
              '/work/help/_site_tmp/_help_tutorials_create-interactive-hover-effects-with-mapbox-gl-js.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-new-map-style-with-cartogram-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-new-map-style-with-cartogram-video" */
              '/work/help/_site_tmp/_help_tutorials_create-new-map-style-with-cartogram-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/create-tileset-with-mapbox-tiling-service-cli-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-create-tileset-with-mapbox-tiling-service-cli-video" */
              '/work/help/_site_tmp/_help_tutorials_create-tileset-with-mapbox-tiling-service-cli-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/custom-markers-gl-js-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-custom-markers-gl-js-video" */
              '/work/help/_site_tmp/_help_tutorials_custom-markers-gl-js-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/custom-markers-gl-js/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-custom-markers-gl-js" */
              '/work/help/_site_tmp/_help_tutorials_custom-markers-gl-js.js'
            ),
            
            
          },{
            path: '/help/tutorials/custom-markers-studio-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-custom-markers-studio-video" */
              '/work/help/_site_tmp/_help_tutorials_custom-markers-studio-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/customize-label-text-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-customize-label-text-video" */
              '/work/help/_site_tmp/_help_tutorials_customize-label-text-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/customize-label-text/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-customize-label-text" */
              '/work/help/_site_tmp/_help_tutorials_customize-label-text.js'
            ),
            
            
          },{
            path: '/help/tutorials/data-joins-with-mapbox-boundaries-v3/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-data-joins-with-mapbox-boundaries-v3" */
              '/work/help/_site_tmp/_help_tutorials_data-joins-with-mapbox-boundaries-v3.js'
            ),
            
            
          },{
            path: '/help/tutorials/data-joins-with-mapbox-boundaries/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-data-joins-with-mapbox-boundaries" */
              '/work/help/_site_tmp/_help_tutorials_data-joins-with-mapbox-boundaries.js'
            ),
            
            
          },{
            path: '/help/tutorials/deploy-collaborative-map-quick-launch-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-deploy-collaborative-map-quick-launch-video" */
              '/work/help/_site_tmp/_help_tutorials_deploy-collaborative-map-quick-launch-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/extending-interactivity/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-extending-interactivity" */
              '/work/help/_site_tmp/_help_tutorials_extending-interactivity.js'
            ),
            
            
          },{
            path: '/help/tutorials/find-elevations-with-tilequery-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-find-elevations-with-tilequery-api" */
              '/work/help/_site_tmp/_help_tutorials_find-elevations-with-tilequery-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/geocode-and-sort-stores/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-geocode-and-sort-stores" */
              '/work/help/_site_tmp/_help_tutorials_geocode-and-sort-stores.js'
            ),
            
            
          },{
            path: '/help/tutorials/get-started-isochrone-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-get-started-isochrone-api" */
              '/work/help/_site_tmp/_help_tutorials_get-started-isochrone-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/get-started-map-matching-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-get-started-map-matching-api" */
              '/work/help/_site_tmp/_help_tutorials_get-started-map-matching-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/get-started-mts-and-tilesets-cli/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-get-started-mts-and-tilesets-cli" */
              '/work/help/_site_tmp/_help_tutorials_get-started-mts-and-tilesets-cli.js'
            ),
            
            
          },{
            path: '/help/tutorials/get-started-tokens-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-get-started-tokens-api" */
              '/work/help/_site_tmp/_help_tutorials_get-started-tokens-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/getting-started-directions-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-getting-started-directions-api" */
              '/work/help/_site_tmp/_help_tutorials_getting-started-directions-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/google-to-mapbox-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-google-to-mapbox-video" */
              '/work/help/_site_tmp/_help_tutorials_google-to-mapbox-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/google-to-mapbox/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-google-to-mapbox" */
              '/work/help/_site_tmp/_help_tutorials_google-to-mapbox.js'
            ),
            
            
          },{
            path: '/help/tutorials/improve-perceived-performance-with-static/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-improve-perceived-performance-with-static" */
              '/work/help/_site_tmp/_help_tutorials_improve-perceived-performance-with-static.js'
            ),
            
            
          },{
            path: '/help/tutorials/install-atlas-docker-compose-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-install-atlas-docker-compose-video" */
              '/work/help/_site_tmp/_help_tutorials_install-atlas-docker-compose-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/ios-navigation-sdk-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-ios-navigation-sdk-video" */
              '/work/help/_site_tmp/_help_tutorials_ios-navigation-sdk-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/ios-navigation-sdk/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-ios-navigation-sdk" */
              '/work/help/_site_tmp/_help_tutorials_ios-navigation-sdk.js'
            ),
            
            
          },{
            path: '/help/tutorials/ios-vision-ar-customization/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-ios-vision-ar-customization" */
              '/work/help/_site_tmp/_help_tutorials_ios-vision-ar-customization.js'
            ),
            
            
          },{
            path: '/help/tutorials/ios-vision-poi-drawing/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-ios-vision-poi-drawing" */
              '/work/help/_site_tmp/_help_tutorials_ios-vision-poi-drawing.js'
            ),
            
            
          },{
            path: '/help/tutorials/ios-vision-safety-alerts/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-ios-vision-safety-alerts" */
              '/work/help/_site_tmp/_help_tutorials_ios-vision-safety-alerts.js'
            ),
            
            
          },{
            path: '/help/tutorials/local-search-geocoding-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-local-search-geocoding-api" */
              '/work/help/_site_tmp/_help_tutorials_local-search-geocoding-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/make-a-heatmap-with-mapbox-gl-js/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-make-a-heatmap-with-mapbox-gl-js" */
              '/work/help/_site_tmp/_help_tutorials_make-a-heatmap-with-mapbox-gl-js.js'
            ),
            
            
          },{
            path: '/help/tutorials/mapbox-arcgis-qgis/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-mapbox-arcgis-qgis" */
              '/work/help/_site_tmp/_help_tutorials_mapbox-arcgis-qgis.js'
            ),
            
            
          },{
            path: '/help/tutorials/mapbox-gl-js-expressions/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-mapbox-gl-js-expressions" */
              '/work/help/_site_tmp/_help_tutorials_mapbox-gl-js-expressions.js'
            ),
            
            
          },{
            path: '/help/tutorials/markers-js/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-markers-js" */
              '/work/help/_site_tmp/_help_tutorials_markers-js.js'
            ),
            
            
          },{
            path: '/help/tutorials/mms-map/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-mms-map" */
              '/work/help/_site_tmp/_help_tutorials_mms-map.js'
            ),
            
            
          },{
            path: '/help/tutorials/optimization-api/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-optimization-api" */
              '/work/help/_site_tmp/_help_tutorials_optimization-api.js'
            ),
            
            
          },{
            path: '/help/tutorials/overpass-turbo/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-overpass-turbo" */
              '/work/help/_site_tmp/_help_tutorials_overpass-turbo.js'
            ),
            
            
          },{
            path: '/help/tutorials/point-in-polygon-query-with-mapbox-boundaries/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-point-in-polygon-query-with-mapbox-boundaries" */
              '/work/help/_site_tmp/_help_tutorials_point-in-polygon-query-with-mapbox-boundaries.js'
            ),
            
            
          },{
            path: '/help/tutorials/power-bi-choropleth-map/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-power-bi-choropleth-map" */
              '/work/help/_site_tmp/_help_tutorials_power-bi-choropleth-map.js'
            ),
            
            
          },{
            path: '/help/tutorials/power-bi/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-power-bi" */
              '/work/help/_site_tmp/_help_tutorials_power-bi.js'
            ),
            
            
          },{
            path: '/help/tutorials/processing-satellite-imagery/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-processing-satellite-imagery" */
              '/work/help/_site_tmp/_help_tutorials_processing-satellite-imagery.js'
            ),
            
            
          },{
            path: '/help/tutorials/receipt-map-pt-1/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-receipt-map-pt-1" */
              '/work/help/_site_tmp/_help_tutorials_receipt-map-pt-1.js'
            ),
            
            
          },{
            path: '/help/tutorials/receipt-map-pt-2/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-receipt-map-pt-2" */
              '/work/help/_site_tmp/_help_tutorials_receipt-map-pt-2.js'
            ),
            
            
          },{
            path: '/help/tutorials/reproject-data-to-albers-usa-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-reproject-data-to-albers-usa-video" */
              '/work/help/_site_tmp/_help_tutorials_reproject-data-to-albers-usa-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/route-avoidance-with-turf-mapbox-directions/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-route-avoidance-with-turf-mapbox-directions" */
              '/work/help/_site_tmp/_help_tutorials_route-avoidance-with-turf-mapbox-directions.js'
            ),
            
            
          },{
            path: '/help/tutorials/route-finder-with-turf-mapbox-directions/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-route-finder-with-turf-mapbox-directions" */
              '/work/help/_site_tmp/_help_tutorials_route-finder-with-turf-mapbox-directions.js'
            ),
            
            
          },{
            path: '/help/tutorials/share-map-style-download-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-share-map-style-download-video" */
              '/work/help/_site_tmp/_help_tutorials_share-map-style-download-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/share-map-style-with-link-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-share-map-style-with-link-video" */
              '/work/help/_site_tmp/_help_tutorials_share-map-style-with-link-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/show-changes-over-time/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-show-changes-over-time" */
              '/work/help/_site_tmp/_help_tutorials_show-changes-over-time.js'
            ),
            
            
          },{
            path: '/help/tutorials/static-images-style-params/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-static-images-style-params" */
              '/work/help/_site_tmp/_help_tutorials_static-images-style-params.js'
            ),
            
            
          },{
            path: '/help/tutorials/static-images-text/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-static-images-text" */
              '/work/help/_site_tmp/_help_tutorials_static-images-text.js'
            ),
            
            
          },{
            path: '/help/tutorials/studio-components-eject-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-studio-components-eject-video" */
              '/work/help/_site_tmp/_help_tutorials_studio-components-eject-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/studio-components-style-map-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-studio-components-style-map-video" */
              '/work/help/_site_tmp/_help_tutorials_studio-components-style-map-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/studio-heatmap-tutorial/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-studio-heatmap-tutorial" */
              '/work/help/_site_tmp/_help_tutorials_studio-heatmap-tutorial.js'
            ),
            
            
          },{
            path: '/help/tutorials/style-single-country/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-style-single-country" */
              '/work/help/_site_tmp/_help_tutorials_style-single-country.js'
            ),
            
            
          },{
            path: '/help/tutorials/tableau-prep-for-batch-geocoding-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-tableau-prep-for-batch-geocoding-video" */
              '/work/help/_site_tmp/_help_tutorials_tableau-prep-for-batch-geocoding-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/tilequery-healthy-food-finder/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-tilequery-healthy-food-finder" */
              '/work/help/_site_tmp/_help_tutorials_tilequery-healthy-food-finder.js'
            ),
            
            
          },{
            path: '/help/tutorials/unity-custom-map-style/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-unity-custom-map-style" */
              '/work/help/_site_tmp/_help_tutorials_unity-custom-map-style.js'
            ),
            
            
          },{
            path: '/help/tutorials/update-studio-classic-style-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-update-studio-classic-style-video" */
              '/work/help/_site_tmp/_help_tutorials_update-studio-classic-style-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/upload-curl/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-upload-curl" */
              '/work/help/_site_tmp/_help_tutorials_upload-curl.js'
            ),
            
            
          },{
            path: '/help/tutorials/use-custom-map-style-in-tableau-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-use-custom-map-style-in-tableau-video" */
              '/work/help/_site_tmp/_help_tutorials_use-custom-map-style-in-tableau-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/use-data-visualization-component-in-studio-video/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-use-data-visualization-component-in-studio-video" */
              '/work/help/_site_tmp/_help_tutorials_use-data-visualization-component-in-studio-video.js'
            ),
            
            
          },{
            path: '/help/tutorials/use-mapbox-gl-js-with-react/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-use-mapbox-gl-js-with-react" */
              '/work/help/_site_tmp/_help_tutorials_use-mapbox-gl-js-with-react.js'
            ),
            
            
          },{
            path: '/help/tutorials/use-mapbox-js-as-fallback/',
            getPage: () => import(
              /* webpackChunkName: "help-tutorials-use-mapbox-js-as-fallback" */
              '/work/help/_site_tmp/_help_tutorials_use-mapbox-js-as-fallback.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };